<template lang='pug'>
.login
  .login__container
    form#login(autocomplete="off", @submit.prevent="login" method="post")
      vs-row(align="center" flex-direction="column")
        vs-col(:w="12")
          vs-row(justify ="center")
            img(src="@/assets/logo.png" alt="PIMSA Agente de seguros y fianzas")
        vs-col(:w="12" class="login__container__title")
          vs-row(justify ="center")
            span Inicio de Sesión
        vs-col(:w="12" class="login__container__inputs")
          vs-input(v-model="form.email" :label-placeholder='$t("login.email")' shadow type="email")
            template(#icon)
              i.eva.eva-email-outline
        vs-col(:w="12" class="login__container__inputs")
          vs-input(v-model="form.password" :label-placeholder='$t("login.password")' shadow type="password")
            template(#icon)
              i.eva.eva-lock-outline
            template(#message-danger v-if="authError") Correo o contraseña incorrectos
        vs-col(:w="12" class="login__container__inputs")
          vs-checkbox(v-model='form.rememberMe' :loading="loading") {{ $t('login.keep_connected') }}
        vs-col(:w="12" class="login__container__inputs")
          vs-button(block :loading="loading" size="large")
            | {{ $t('login.login') }}
</template>

<script>
import WindowSizeMixin from '../../mixins/WindowSizeMixin'
import AuthMixin from '../../mixins/AuthMixin'

export default {
  name: 'Login',
  mixins: [WindowSizeMixin, AuthMixin]
}
</script>

<style lang="scss" scoped>
.login {
  padding: 24px 36px;
  height: 100%;
  &__container {
    height: 100%;
    &__title {
      margin-top: 20px;
      & span {
        font-weight: 500;
      }
    }
    &__inputs {
      padding-top: 40px;
    }
  }
}
</style>
